<div class="flex-display height-100per">
  <div class=" float-L width-80 height-100per overflow-auto">
    <div class="pr-5rem pt-3" id="scrollToTop">
      <div class="pendingheading prl-16px pb-24px" tabindex="0">{{pc_header}}</div>
      <div class="warning-rectangle ml-1 flex-display">
        <div class="ptr-18">
          <img src="../../../assets/icons/warning-orange.svg" class="info-img" alt="Warning Icon">
        </div>
        <div class="ptb-18 infoWarningPCS" tabindex="0" [innerHTML]="pc_warning">
        </div>
      </div>
      <div *ngIf="isPCSIntegrated" class="mt-1rem">
        <div class="flex-display info-box-PCS ">
          <div class="infoWarningPCS flex-display font-size-18px ml-1" tabindex="0"><strong> {{pc_enabled}}</strong></div>
          <div class=" flex-display ">
            <button class="btn-small-PCS cursor-pointer ml-10rem mt-0-6rem" (click)="ViewProfile()">{{pc_viewprofile}}</button>
            <button class="btn-small-PCS cursor-pointer  ml-1 mt-0-6rem" (click)="Reset()" (keyup.enter)="Reset()" tabindex="0">{{pc_clearprofile}}</button>
          </div>
        </div>
      </div>
      <div class="pcform  prl-16px">
        <form [formGroup]="pendingContentFormGroup" class="flex-display flex-direction-column">
          <mat-form-field class="width-513px pb-1rem" appearance="fill" id="datePicker" appHostListenerClick>
            <mat-label>{{pc_beginningDate}}</mat-label>
            <input matInput [min]="minDate" [max]="maxDate" [matDatepicker]="picker" autofocusdropdown="true" formControlName="datePicker" (dateChange)="addEvent('change', $event)">
            <mat-datepicker-toggle matSuffix [for]="picker" appHostListenerClick></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
          <mat-error class="mat-field-hint mb-1 mt-1 width-513px" *ngIf="DateError != ''"> {{DateError}}</mat-error>

          <mat-form-field class="width-513px pb-1rem" appHostListenerClick>
            <mat-label>{{pc_filingStatuslabel}}</mat-label>
            <mat-select #feedBackTypeSelect (selectionChange)="onFillingStatusChange($event)" placeholder="Select Filling Status" formControlName="fillingstatusdefault">
              <mat-option class="bgc-blue" *ngFor="let type of pc_Fillingstatus" [value]="type">{{type}}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-error class="mat-field-hint mb-1 mt-1 width-513px" *ngIf="FillingStatusError != ''"> {{FillingStatusError}}</mat-error>

          <mat-form-field class="width-513px pb-1rem" appHostListenerClick>
            <mat-label>{{pc_periodtypelabel}}</mat-label>
            <mat-select #feedBackTypeSelect (selectionChange)="onPeriodTypeChange($event)" placeholder="Select Period Type" formControlName="periodtypedefault">
              <mat-option class="bgc-blue" *ngFor="let type of pc_periodtype" [value]="type">{{type}}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-error class="mat-field-hint mb-1 mt-1 width-513px" *ngIf="PeriodTypeError != ''"> {{PeriodTypeError}}</mat-error>
        </form>
        <div  *ngIf="isPCSIntegrated || isPCSIntegratedFromBackButton" class="mt-1rem"> <button mat-button class="pccontinue" (click)="submitfromEdit()" (keyup.enter)="submitfromEdit()" tabindex="0">{{pc_buttonSubmit}}</button></div>
        <div class="specialcase-continue pb-2rem pt-56 width-90">
          <button mat-button class="pccontinue" (click)="continuepc(false)" (keyup.enter)="continuepc(false)" tabindex="0" *ngIf="isButton1">{{pc_continue}}</button>
          <div *ngIf="iscontinue">
            <div class="width-105">
              <div class="specialcase-header">{{pc_headerSpecialCases}}</div>
              <div class="the-following-standa ">{{pc_bodySpecialCases}}</div>
            </div>
            <div class="check-yesno-if-the-pro"><ul><li [innerHTML]="pc_bodySpecialCasesYes"></li><li [innerHTML]="pc_bodySpecialCasesNo"></li></ul></div>
            <table mat-table [dataSource]="dataSource" class="custom-mattable" aria-label="SpecialCases" aria-describedby="pendingcontent1">
              <ng-container matColumnDef="Standardssource">
                <th scope="col" mat-header-cell *matHeaderCellDef>{{pc_standardsSource}}</th>
                <td mat-cell *matCellDef="let element"><img class="pdfimage" src="../../../assets/icons/PDF_icon.svg" alt="PDF Image" /> <a class="h-20px cursor-pointer" id={{element.standsourcepdffileName}} (click)="openLinkById($event)">{{element.title}} </a></td>
                <td mat-footer-cell *matFooterCellDef> </td>
              </ng-container>
              <ng-container matColumnDef="Transitionguidanceparagraph" class="font-blue">
                <th scope="col" mat-header-cell *matHeaderCellDef>{{pc_transitionParagraph}}</th>
                <td mat-cell *matCellDef="let element"> <a class="h-20px highlight-blue cursor-pointer" (click)="OpenRightOverlay(element)" (keyup.enter)="OpenRightOverlay(element)" tabindex="0">{{element.transistionguidance}}</a></td>
                <td mat-footer-cell *matFooterCellDef> </td>
              </ng-container>
              <ng-container matColumnDef="Title" class="font-blue">
                <th scope="col" mat-header-cell *matHeaderCellDef>Title</th>
                <td mat-cell *matCellDef="let element">{{element.body}}</td>
                <td mat-footer-cell *matFooterCellDef>
                  <label>{{pc_batchIntegration}}</label>
                </td>
              </ng-container>
              <ng-container matColumnDef="Integrate">
                <th scope="col" mat-header-cell *matHeaderCellDef> {{pc_integrate}}</th>
                <td mat-cell *matCellDef="let element">
                  <mat-radio-group aria-label="Select an option" [(ngModel)]="element.yesOrNo" (change)="radioButtonChange()">
                    <mat-radio-button [value]="1" [checked]="element.yesOrNo == 1">{{pc_yes}}</mat-radio-button>
                    <mat-radio-button [value]="2" [checked]="element.yesOrNo == 2">{{pc_no}}</mat-radio-button>
                  </mat-radio-group>
                </td>
                <td mat-footer-cell *matFooterCellDef>

                  <mat-radio-group aria-label="Select an option" [(ngModel)]="SC_Checked">
                    <mat-radio-button value="1" [checked]="SC_Checked == 1" (click)="CheckAll('yes','SpecialCases')" (keyup.enter)="CheckAll('yes','SpecialCases')" tabindex="0">{{pc_all}}</mat-radio-button>
                    <mat-radio-button value="2" [checked]="SC_Checked == 2" (click)="CheckAll('no','SpecialCases')" (keyup.enter)="CheckAll('no','SpecialCases')" tabindex="0">{{pc_none}}</mat-radio-button>
                  </mat-radio-group>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>

            </table>
            <div *ngIf="dataSource.data.length === 0" class="align-items-center text-align-norecords">{{noRecords}}</div>
            <div class="earlyadoption-continue">
              <button mat-button class="pccontinue" (click)="continuepc2(false)" *ngIf="isButton2" (keyup.enter)="continuepc2(false)" tabindex="0">{{pc_continue}}</button>
              <button class="pccontinue ml-1" *ngIf="isButton2" (click)="Reset()" (keyup.enter)="Reset()" tabindex="0">Reset</button>
              <div class="earlyadoptionbody" *ngIf="iscontinue2">
                <div><span class="specialcase-header">{{pc_headerEarlyAdoptions}} </span><span class="optional-input">{{pc_optionalInput}}</span></div>
                <div class="width-105">
                  <div class="the-following-standa ">{{pc_bodyEarlyAdoptions}}</div>
                  <div class="check-yesno-if-the-pro"><ul><li class="mb-1" [innerHTML]="pc_bodyEarlyAdoptionsYes"></li><li class="mb-1" [innerHTML]="pc_bodyEarlyAdoptionsNo"></li></ul></div>
                </div>
                <table mat-table [dataSource]="dataSource2" class="custom-mattable" aria-label="EarlyAdoptions" aria-describedby="pendingcontent2">
                  <ng-container matColumnDef="Standardssource">
                    <th scope="col" mat-header-cell *matHeaderCellDef>{{pc_standardsSource}}</th>
                    <td mat-cell *matCellDef="let element"><img class="pdfimage" src="../../../assets/icons/PDF_icon.svg" alt="PDF Image 2" />   <a class="h-20px cursor-pointer" id={{element.standsourcepdffileName}} (click)="openLinkById($event)">{{element.title}}</a> </td>
                    <td mat-footer-cell *matFooterCellDef> </td>
                  </ng-container>
                  <ng-container matColumnDef="Transitionguidanceparagraph">
                    <th scope="col" mat-header-cell *matHeaderCellDef>{{pc_transitionParagraph}}</th>
                    <td mat-cell *matCellDef="let element"><a class="h-20px highlight-blue cursor-pointer" (click)="OpenRightOverlay(element)" (keyup.enter)="OpenRightOverlay(element)" tabindex="0">{{element.transistionguidance}} </a> </td>
                    <td mat-footer-cell *matFooterCellDef> </td>
                  </ng-container>

                  <ng-container matColumnDef="Title" class="font-blue">
                    <th scope="col" mat-header-cell *matHeaderCellDef>Title</th>
                    <td mat-cell *matCellDef="let element">{{element.body}}</td>
                    <td mat-footer-cell *matFooterCellDef>
                      <label>{{pc_batchIntegration}}</label>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="Integrate">
                    <th scope="col" mat-header-cell *matHeaderCellDef> {{pc_integrate}}</th>
                    <td mat-cell *matCellDef="let element">
                      <mat-radio-group aria-label="Select an option" [(ngModel)]="element.yesOrNo" (change)="radioButtonChange()">
                        <mat-radio-button [value]="1" [checked]="element.yesOrNo == 1">{{pc_yes}}</mat-radio-button>
                        <mat-radio-button [value]="2" [checked]="element.yesOrNo == 2">{{pc_no}}</mat-radio-button>
                      </mat-radio-group>
                    </td>
                    <td mat-footer-cell *matFooterCellDef>
                      <mat-radio-group aria-label="Select an option" [(ngModel)]="EA_Checked">
                        <mat-radio-button value="1" [checked]="EA_Checked == 1" (click)="CheckAll('yes','EarlyAdoptions')" (keyup.enter)="CheckAll('yes','EarlyAdoptions')" tabindex="0">{{pc_all}}</mat-radio-button>
                        <mat-radio-button value="2" [checked]="EA_Checked == 2" (click)="CheckAll('no','EarlyAdoptions')" (keyup.enter)="CheckAll('no','EarlyAdoptions')" tabindex="0">{{pc_none}}</mat-radio-button>
                      </mat-radio-group>
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                  <ng-container *ngIf="dataSource2.data.length != 0"> <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr></ng-container>
                </table>
                <div *ngIf="dataSource2.data.length === 0" class="align-items-center text-align-norecords">{{noRecords}}</div>
                <div class="earlyadoption-continue flex-display">
                  <button [ngClass]="(dataSource2.data.length == 0 && dataSource.data.length == 0) ? 'pccontinue-disabled' : 'pccontinue cursor-pointer' " (keyup.enter)="pendingintegeration()" tabindex="0" (click)="pendingintegeration()" *ngIf="isButton3" [disabled]="dataSource2.data.length == 0 && dataSource.data.length == 0">{{pc_buttonSubmit}}</button>
                  <button class="pccontinue ml-1" (click)="Reset()" (keyup.enter)="Reset()" tabindex="0">Reset</button>
                </div>

              </div>
              <div id="topLoad" class="links cursor-pointer flex-display pl-12rem float-R text-decoration-none" (click)="gotoSection()" (keyup.enter)="gotoSection()" tabindex="0">
                <span class="pr-0-5rem mt-2 width-5-5rem font-14">{{pc_backtoTop}}</span>
                <span>
                  <img src="../../../assets/icons/ArrowUp-white.svg" class="selectedNavElement search_arrow_icon mt-1-5rem" alt="Back to top">
                </span>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="rightfloat_pc float-R">
    <div class="padding-right-pc">
      <div class="for-information-on-h pb-16">{{pc_linkDescription}}</div>
      <div class="plb-8-16">
        <div class="hyperlink-text highlight-blue border-bottom-help flex-display cursor-pointer">{{pc_howToUseCod}}</div>
      </div>
      <div class="plb-8-16">
        <div class="hyperlink-text highlight-blue border-bottom-help flex-display cursor-pointer right-Overlay" id="pcsfaq" appHostListenerClick>{{pc_FAQ}}</div>
      </div>
      <div class="plb-8-16">
        <div class="hyperlink-text highlight-blue border-bottom-help flex-display cursor-pointer right-Overlay" id="pcsfaq-limitations" appHostListenerClick>{{pc_limitations}}</div>
      </div>
      <div class="plb-8-16">
        <div class="hyperlink-text highlight-blue border-bottom-help flex-display cursor-pointer right-Overlay" id="generalFeedback" appHostListenerClick>{{generalFeedback}}</div>
      </div>
    </div>

  </div>
</div>

